import React from 'react';

const CreditCardIcon = () => (
  <svg
    className='credit-card-icon'
    width='120'
    height='80'
    viewBox='0 0 120 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <defs>
      <clipPath id='credit-card-clip'>
        <rect x='4' y='8' width='112' height='64' rx='10' />
      </clipPath>
    </defs>
    <rect
      x='4'
      y='8'
      width='112'
      height='64'
      rx='10'
      stroke='#000'
      strokeWidth='3'
      fill='#fff'
    />
    <g clipPath='url(#credit-card-clip)'>
      <rect x='4' y='20' width='112' height='16' fill='#810EA9' />
    </g>
    <rect x='68' y='56' width='34' height='3' fill='#000' />
  </svg>
);

export default CreditCardIcon;
